import { useQuery } from "@tanstack/react-query";
import { useAxios } from "../../../api/axios";
import { useTranslation } from "react-i18next";

export const useUnreadNotificationsCount = () => {
  const axios = useAxios();
  const { t } = useTranslation();

  return useQuery({
    queryKey: ["notifications-unread-count"],
    queryFn: async () => {
      const urlKey = t("calling-pipeline-notifications");
      const response = await axios.get(`${urlKey}/count`);
      return response.data;
    },
    refetchOnWindowFocus: false
  });
};
